import React from "react";

export class IconItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hoveredIcon: false
        };
    }
    hoverEnd() {
        return this.setState({
            hoveredIcon: false
        });
    }
    handleHover() {
        return this.setState({
            hoveredIcon: true
        });
    }
    onIMGLoad() {
        return this.setState({
            imgLoaded: true
        });
    }
    onSelectIcon(event) {
        event.preventDefault();
        return this.props.onSelectIcon(this.props.icon, this.props.iconKey);
    }
    render() {
        let icon, img_size, myClass;
        icon = this.props.icon;
        switch (this.props.iconsPerRow) {
            case 12:
                img_size = icon.preview_url_84;
                break;
            case 6:
                img_size = icon.preview_url;
        }
        myClass = "Grid-cell";
        if (this.props.selected === true) {
            myClass += " selected";
        }
        if (this.state.imgLoaded === true) {
            myClass += " loaded";
        }
        return (
            <div
                key={icon.id}
                className={myClass}
                onClick={this.onSelectIcon.bind(this)}
                onMouseEnter={this.handleHover.bind(this)}
                onMouseLeave={this.hoverEnd.bind(this)}
            >
                <a
                    href={this.props.icon.permalink}
                    title={this.props.icon.term}
                >
                    <img
                        onLoad={this.onIMGLoad.bind(this)}
                        src={img_size}
                        alt={`${icon.term} Icon ${icon.id}`}
                    />
                </a>
            </div>
        );
    }
}
